import { RecurrenceButton } from "./RecurrenceButton";
import { translations } from "./recurrence_translations";

export const RecurrenceFormHandler = {
	async refresh(frm) {
		await RecurrenceFormHandler.recurrence_show_instances(frm);

		frm.set_df_property("rrule", "depends_on", "eval:true");
		frm.set_df_property("rrule", "hidden", false);

		frm.set_df_property("repeat_this_event", "hidden", true);
		frm.set_df_property("repeat_till", "hidden", true);
		frm.set_df_property("repeat", "hidden", true);

		const wrapper = frm.get_field("rrule").wrapper;
		const button = new RecurrenceButton(wrapper, frm);
	},

	before_save(frm) {
		return RecurrenceFormHandler.recurrence_before_save(frm);
	},

	get_field_map(frm) {
		return frappe.views?.calendar?.[frm.doctype]?.field_map;
	},

	get_field_name(frm, key, fallback) {
		return RecurrenceFormHandler.get_field_map(frm)?.[key] ?? fallback;
	},

	async recurrence_show_instances(frm) {
		if (!frm.doc.rrule_group) {
			return;
		}

		frm.sidebar.sidebar.find(".recurrence-calendar-section").remove();

		const section = document.createElement("div");
		section.classList.add("sidebar-section", "recurrence-calendar-section");

		const timelineSection = frm.sidebar.sidebar.find(".dodock-document-timeline").get(0);
		timelineSection.after(section);

		const sectionLabelWrapper = document.createElement("div");
		sectionLabelWrapper.classList.add("sidebar-label", "ellipsis");
		sectionLabelWrapper.innerHTML = frappe.utils.icon("calendar-sync", "sm");

		const sectionLabel = document.createElement("span");
		sectionLabel.classList.add("ellipsis");
		sectionLabel.textContent = translations.sidebar_section_title();

		sectionLabelWrapper.append(sectionLabel);
		section.append(sectionLabelWrapper);

		const actions = document.createElement("div");
		section.append(actions);

		// const helpTextDiv = document.createElement("div");
		// helpTextDiv.classList.add("text-sm", "text-muted", "mb-2");
		// helpTextDiv.style.lineHeight = "1.3";
		// helpTextDiv.textContent = "Click on the calendar to go to the event recurrence";
		// actions.append(helpTextDiv);

		const goToList = document.createElement("button");
		goToList.classList.add("btn", "btn-default", "btn-xs", "mb-2");
		goToList.innerHTML = frappe.utils.icon("list") + "&nbsp;";
		goToList.append("Voir la liste");
		goToList.addEventListener("click", () => {
			frappe.set_route("List", frm.doctype, "List", { rrule_group: frm.doc.rrule_group });
		});
		actions.append(goToList);

		const div = document.createElement("div");
		div.style.fontSize = "11px";
		div.classList.add("fc--unstyled", "fc--micro");
		section.append(div);

		await frappe.require("calendar.bundle.js");
		const field_map = RecurrenceFormHandler.get_field_map(frm);
		const fc = new frappe.FullCalendar(div, {
			locale: frappe.boot.lang,
			plugins: frappe.FullCalendar.LimitedPlugins,
			headerToolbar: {
				left: "title",
				center: "",
				right: "prev,next",
			},
			initialView: "dayGridMonth",
			height: 270,
			firstDay: frappe.datetime.get_first_day_of_the_week_index(),
			eventContent: (arg) => {
				return "";
			},
			eventDidMount: (arg) => {
				if (!arg.backgroundColor || arg.backgroundColor === "null") {
					arg.backgroundColor = "var(--blue)";
				}
				arg.el.style.border = "none";
				arg.el.style.backgroundColor = arg.backgroundColor;
				arg.el.style.minHeight = "1em";
				arg.el.style.boxShadow = "0 0 0 0.5px white";
				arg.el.style.opacity = "0.5";

				arg.el.title = arg.timeText;

				if (frm.doc.name && arg.event.extendedProps.name === frm.doc.name) {
					const frame = arg.el.closest(".fc-daygrid-day-frame");
					frame.style.backgroundColor = "var(--yellow)";
					frame.style.color = "black";
					frame.style.fontWeight = "bold";
					arg.el.style.boxShadow = "0 0 0 1px white";
					arg.el.style.opacity = "1";
				}
			},
			// eventClick: async (arg) => {
			// 	if (arg.event.extendedProps.name) {
			// 		frappe.set_route("Form", frm.doctype, arg.event.extendedProps.name);
			// 	}
			// },
			events: async (parameters, callback) => {
				const events = await frappe.xcall("frappe.desk.calendar.get_events", {
					doctype: frm.doctype,
					start: frappe.datetime.convert_to_system_tz(parameters.start),
					end: frappe.datetime.convert_to_system_tz(parameters.end),
					filters: [[frm.doctype, "rrule_group", "=", frm.doc.rrule_group]],
					field_map: field_map,
				});
				for (const event of events) {
					for (const [k, v] of Object.entries(field_map)) {
						event[k] = event[v];
					}
					event.url = frappe.utils.get_form_link(frm.doctype, event.name);
				}
				callback(events);
			},
		});
		fc.render();
	},

	recurrence_before_save: (frm) => {
		if (!frm.is_dirty()) {
			return;
		}
		if (!frm.doc.rrule_group) {
			return;
		}

		const start_fieldname = RecurrenceFormHandler.get_field_name(frm, "start", "starts_on");

		const translationArgs = [
			frm.doc[start_fieldname]
				? frappe.datetime.get_datetime_as_string(frm.doc[start_fieldname])
				: "?",
		]
		const options = [
			{
				label: translations.edit_event_this(translationArgs),
				value: "one",
				action: () => {
					frm.doc._recurrence_action = "one";
				},
			},
			{
				label: translations.edit_event_next(),
				value: "next",
				action: () => {
					frm.doc._recurrence_action = "next";
				},
			},
			{
				label: translations.edit_event_all(),
				value: "all",
				action: () => {
					frm.doc._recurrence_action = "all";
				},
			},
		];

		if (frm.doc.rrule) {
			options.shift();
		}

		return new Promise((resolve, reject) => {
			const dialog = new frappe.ui.Dialog({
				title: translations.edit_event_modal_title(),
				primary_action_label: "OK",
				primary_action: () => {
					const optValue = dialog.body.querySelector("input[type=radio]:checked")?.value;
					const opt = options.find((opt) => opt.value == optValue);
					opt?.action?.();

					reject = null;
					dialog.hide(); // hide AFTER disabling the rejection
					resolve();
				},
				on_hide: () => {
					reject?.();
				},
			});

			const div = document.createElement("div");
			div.classList.add("flex", "flex-column");
			for (const opt of options) {
				const label = document.createElement("label");
				const radio = document.createElement("input");
				radio.name = "choice";
				radio.type = "radio";
				radio.value = opt.value;
				label.append(radio, opt.label);
				div.append(label);
			}
			div.querySelector("input[type=radio]").checked = true;
			dialog.body.append(div);
			dialog.show();
		});
	},
};
